<script>
    import wrappedFetch from "../../wrappedFetch.js";
    import Modal from "../components/modal.svelte";
    import Button from "../components/button.svelte";
    import {createEventDispatcher} from 'svelte';
    import Datepicker from 'svelte-calendar';
    import moment from "moment";
    import {getUTCDate} from "../../store.js"
    let ModalConfirmation = false;

    export let userDetails; 
    export let showRenewModal = false;
    const dispatch = new createEventDispatcher();
    let isButtonLoading = false;
    let start = new Date();
    let currrentSubscriptionStart="", currentSubscriptionRenewal="", annualFee="395";
    let oldcurrrentSubscriptionStart, oldcurrentSubscriptionRenewal, oldannualFee, active=false, pending=false;;
    let CustomerID = 0;
    let d = new Date();   
    let year = d.getFullYear();
    let month = d.getMonth();
    let day = d.getDate();
    let dateChosen = false, dateChosen2 = false;
    let dateFormat = '#{d}/#{m}/#{Y}';
    let CalendarStart = new Date(year, month - 6, day);
    let CalendarEnd = new Date(year + 6, month, day);
    let RenewalDate = new Date(year + 1, month, day);

    if (userDetails){
        CustomerID = userDetails.customersID;
        oldannualFee = userDetails.annualFee;
        oldcurrentSubscriptionRenewal = userDetails.currentSubscriptionRenewal;
        pending = userDetails.isEnabled;
        active = userDetails.active;
    }

        currrentSubscriptionStart = moment(d).format("DD/MM/YYYY");

        const RenewEstablish=async()=> {
            isButtonLoading = true;
        const oldDate = new Date(start.getTime() + 1000 * 3600 * 24 * 720);
        let tempOld = oldDate;
       
        if (oldcurrentSubscriptionRenewal){
            tempOld = new Date(oldcurrentSubscriptionRenewal);
        }
        else {
            tempOld = oldDate;
        }

        let olddetails = {
            customersID: CustomerID,
            annualFee: oldannualFee,
            RenewalDate: new Date(tempOld)
        };

        let datecurrentSubscriptionRenewal = moment(currentSubscriptionRenewal, "DD/MM/YYYY");
        let newdatecurrentSubscriptionRenewal = getUTCDate(datecurrentSubscriptionRenewal)

        let newdetails = {
            customersID: CustomerID,
            annualFee: annualFee,
            RenewalDate:newdatecurrentSubscriptionRenewal
        };
        let data = {olddetails, newdetails};

        let resp = await wrappedFetch(
            `/api/subscriptions/UpdateRenewalDetails`,
            {
               method: "post",
                body: JSON.stringify(newdetails),
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        dispatch('renew');
        isButtonLoading=false;
        ModalConfirmation = true;       
    }
</script>
<Modal showModal={showRenewModal} on:close={()=>{showRenewModal=false;dispatch('close')}} sizeClass="modal-md" hideScrollY={true}>
    <div slot="header" style="width:100%">
        <div class="row">
            <div class="col text-left"><h3 class="text-white">Renew subscription</h3></div>
        </div>
    </div>
    <div slot="content">
        {#if ModalConfirmation}
            <div class="alert alert-success">Your subscription has successfully been updated</div>
        {:else}
            <div class="form-group d-none">
                New Subscription Start Date
                <Datepicker bind:formattedSelected={currrentSubscriptionStart} bind:dateChosen style="width:100%" format={dateFormat}>
                    <input type="text" class="form-control" bind:value={currrentSubscriptionStart}>                        
                </Datepicker>
            </div>
            <div class="form-group">
                Current Subscription Renewal Date
                <Datepicker bind:formattedSelected={currentSubscriptionRenewal} bind:dateChosen2 style="width:100%" format={dateFormat} start={CalendarStart} end={CalendarEnd} selected={RenewalDate}>
                    <input type="text" class="form-control" bind:value={currentSubscriptionRenewal}>
                </Datepicker>
            </div>
            <div class="form-group">
                Annual Fee(£)
                <input type="text" class="form-control" bind:value={annualFee}>
            </div>
        {/if}
    </div>
    <div slot="footer">
        {#if !ModalConfirmation}
        <Button buttonClass={"btn-primary"} buttonText={"Save"} bind:isLoading={isButtonLoading} on:click={RenewEstablish}/>
            <!-- <button class="btn btn-primary" type="button" on:click={RenewEstablish}>Save</button> -->
        {/if}
    </div>
</Modal>